// The search grammar's token rules, shared by the search page's facets
// controller and the section drawer's starter chips (#3523): one spelling
// of what the parser (Search::ParsedQuery) does. Tokens compare
// case-insensitively, as every parser pattern is /i, and a single-slot
// operator holds one value, the first: a second one is dead text.

// Quoted-operator tokens first (in:"Wine & dining"), then plain runs
const TOKEN = /-?\w+:"[^"]*"|\S+/g
// is: has exactly one recognized value; is:anything-else stays search text
export const OPERATOR = /^-?(tag|in|site|before|after|broken-before|broken-after|added|status|archived|type):|^is:untagged$/i
const SINGLE_SLOT = ["in:", "site:", "before:", "after:", "broken-before:", "broken-after:", "added:", "status:", "archived:", "type:"]

export function split(value) {
  return (value || "").match(TOKEN) || []
}

export function same(a, b) {
  return a.toLowerCase() === b.toLowerCase()
}

export function includes(list, token) {
  return list.some((candidate) => same(candidate, token))
}

export function without(list, tokens) {
  return list.filter((candidate) => !tokens.some((token) => same(candidate, token)))
}

// Single-slot operators replace their previous value
export function withReplacedSlot(list, token) {
  const slot = SINGLE_SLOT.find((operator) => token.toLowerCase().startsWith(operator))
  const kept = slot ? list.filter((candidate) => !candidate.toLowerCase().startsWith(slot)) : list
  return [...kept, token]
}
